import { styled, alpha } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import { Stack } from '@mui/system';

export const StyledFormContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    // padding: "20px"
}))

export const HeaderSubscriptText = styled('span')(({theme}) => ({
    fontSize: '12px',
    fontStyle: 'italic',
    display: 'flex',
    alignItems: 'end',
    marginLeft: '5px',
    marginBottom: '3px',
}))

export const HeaderUserName = styled('span')(({theme}) => ({
    fontSize: '17px',
    marginRight: '5px',
    color: 'black'
}))

export const HeaderUserRole = styled('span')(({theme}) => ({
    fontSize: '12px',
    marginRight: '5px',
    color: 'black'
}))

export const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
      border: '1px solid gray'
    },
  }));
  
  export const StyledDiv = styled('div')(({ theme }) => ({
    backgroundColor: "transparent", marginLeft: "8px"
  }));

  export const StyledIndexContainerDiv = styled('div')(({ theme }) => ({
    backgroundColor: "white"
  }));

  export const StyledMenuDiv = styled('div')(({ theme }) => ({
  
  }));

  export const StyleTopdDiv = styled('div')(({ theme }) => ({
    marginTop: 30,
  }));

  export const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }));
  
  export const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
      padding: theme.spacing(1, 1, 1, 0),
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        width: '12ch',
        '&:focus': {
          width: '20ch',
        },
      },
    },
  }));

export const ToggleContainer = styled(Stack)({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "16px",
    padding: "0 0 24px 0",
});

  export const StyledLeadContainer = styled('div')(({theme}) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap'
  }));
export const StyledGridContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
  columnGap: {
    sm : "10px",
    md : "30px",
    lg : "50px",
    xl :'130px'
  },
  rowGap: '16px',
  width: '100%',
  alignItems: 'start',

  '& > *': {
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
  },

  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },

  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
  },
}));
  
  export const StyledFieldBox = styled('div')(({ theme }) => ({
  flex: '1 1 22%',
  minWidth: '220px',

  background: 'white',
  padding: '16px',
  borderRadius: '18px',
  boxShadow: '3px 1px 10px 7px whitesmoke',

  [theme.breakpoints.down('sm')]: {
    flex: '1 1 100%',
  }
}));
  
export const StyledAccordionContainer = styled('div')({
  display: "flex",
  gap: "20px",
  flexWrap: "wrap",

  "& > *": {
    flex: "1 1 48%",
    minWidth: "280px"
  }
});

  export const StyledFourGrid = styled('div')(({theme}) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px'
  }));


  export const StyledThreeGrid = styled('div')(({theme}) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
     justifyContent: 'start',
     gap: '20px'
  }));



  export const StyledTwoGrid = styled('div')(({theme}) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    justifyContent: 'start',
    gap: '20px'
  }));


  export const StyledLeadGridContainer = styled('div')(({theme}) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px'
  }));


  export const StyledConfigurationContainer = styled('div')(({theme}) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: "10px",
    paddingBottom: "15px",
    backgroundColor: "#F4F9FE !important",
    
  }));

  export const StyledSearchContainer = styled('div')(({theme}) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: "100%",
    padding: "5px 8px",
    // flexWrap: 'wrap'
    
  }));

  export const StyledflexSpacebetween = styled('div')(({theme}) => ({
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 20,
    flexWrap: 'wrap'
  }));

  export const StyledBaseLineContainer = styled('div')(({theme}) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: "100%",
    flexWrap: 'wrap'
  }));

  export const StyledProductLineContainer = styled('div')(({theme}) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'baseline',
  }));


  export const StyledSubHeader = styled('h5')(({theme}) => ({
    margin: "10px 0px 10px 0px",
    paddingTop: "15px",
    fontSize: "13px"
  }))

  export const StyledAccordionSubHeader = styled('h5')(({theme}) => ({
    fontSize: "17px",
    margin: "0px !important"
  }))

  export const StyledConfigContainer = styled('div')(({theme}) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '5%'
  }));

  export const StyledCompanyContainer = styled('div')(({theme}) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap'
  }));

  export const StyledLookupContainer = styled('div')(({theme}) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: "100%",
    padding: "20px"
  }));

  export const StyledNormalContent = styled('div')(({theme}) => ({
    display: 'flex',
    justifyContent: 'normal',
    
  }));

  export const StyledFlexEnd = styled('div')(({theme}) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      marginTop: '5px',
      marginLeft: "0px !important"
    }
  }))

  export const StyledFlexStart = styled('div')(() => ({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  }))

  export const StyledBlockData = styled('div')(({theme}) => ({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: 30
  }));

  export const StyledBlockDataFlexStart = styled('div')(({theme}) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: 30
}));

  export const StyledCenterContainer = styled('div')(({theme}) => ({
    display: 'flex',
    justifyContent: 'center',
    marginTop: 20
  }))

  export const LeadFooterItem = styled('div')(({theme}) => ({
    display: 'flex',
    // width: '81%',
    width: '100%',
    justifyContent: 'space-around',
    // position: 'fixed',
    bottom: 3,
    background: 'white',
    // marginTop: 20,
    border: '1px solid darkgrey',
    padding: '20px',
    borderRadius: '50px'

  }));

  export const LeadFooterItemContent = styled('div')(({theme}) => ({
    paddingRight: '20px',
    width: '20%',
    textAlign: 'center',
    borderRight: '1px solid darkgrey'
  }))

  export const BlockItem = styled('div')({
    width:  '33.3%',
    paddingRight: '20px',
    textAlign: 'center',
    borderRight: '1px solid darkgrey'
  })
   

  export const LeadFooterItemLastContent = styled('div')(({theme})=> ({
    paddingRight: '20px',
    width: '20%',
    textAlign: 'center',
  }))


  export const CreateLeadFooter= styled('div')(({theme}) => ({
    display: 'flex',
    width: '-webkit-fill-available',
    width: '-moz-fill-available',
    justifyContent: 'space-between',
    position: 'fixed',
    background: 'white',
    top: 64,
    // marginTop: 20,
    // borderTop: '1px solid darkgrey',
    padding: '21px 9px',
    // borderRadius: '50px',
    zIndex: 999,
    backgroundColor: "#F4F9FE",
    // width: "94%"
    width: 'fill-available',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      padding: '9px 9px',
    }
  }));
